import http from '@/requests/http'

class Small {
  static all (params) {
    return http.post('configuration/consultation/small/index', params)
  }
  static async view (params) {
    return http.post('configuration/consultation/small/view', params)
  }
  static async update (data) {
    return http.post('configuration/consultation/small/update', data)
  }
  static async save (data) {
    return http.post('configuration/consultation/small/store', data)
  }
  static async delete (id) {
    return http.post(`configuration/consultation/small/delete/${id}`)
  }
}

export default Small
